import type { Event, EventHint } from "@sentry/types";

const chunkLoadError = (event: Event, hint: EventHint): Event | null => {
  const chunkLoadErrorString = "ChunkLoadError";
  const assetBaseUrl = import.meta.env.BASE_URL;
  const error = hint.originalException as Error | string;

  const isChunkLoadingString = typeof error === "string" && error.includes(chunkLoadErrorString);
  const isChunkLoadingError =
    typeof error !== "string" && error?.name?.includes(chunkLoadErrorString);

  // Vite produces a TypeError whose message contains the failing asset URL.
  // Matching on the asset base path (from Vite's `base` config) is browser-agnostic
  // and stays in sync with the build config automatically.
  const isStaleAssetString =
    typeof error === "string" && error.includes("TypeError") && error.includes(assetBaseUrl);
  const isStaleAssetError =
    typeof error !== "string" &&
    error instanceof TypeError &&
    error?.message?.includes(assetBaseUrl);

  if (isChunkLoadingString || isChunkLoadingError || isStaleAssetString || isStaleAssetError) {
    return null;
  }

  return event;
};

export { chunkLoadError };
